import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import { userGroupUrl } from '@/constants/urls';
import CardItem from '@/components/cards/CardItem';
import UserGroupTools from '../containers/UserGroupTools';

const UserGroupCardItem = ({
  onCheckBoxClick,
  single,
  upward,
  userGroup,
}) => (
  <CardItem className="aridhia-usergroup-list-item">
    <NameDescriptionCard
      description={userGroup.description}
      entity="usergroup"
      link={userGroupUrl(userGroup)}
      markdown
      name={userGroup.name}
      onSelect={onCheckBoxClick ? () => onCheckBoxClick(userGroup.code) : undefined}
      selected={userGroup.selected}
      single={single}
    >
      <UserGroupTools
        iconSize="large"
        listItem
        userGroup={userGroup}
        upward={upward}
        url={userGroupUrl(userGroup, '#')}
      />
    </NameDescriptionCard>
    <Card.Content extra>
      <FormattedMessage
        id="users.count"
        values={{ total: userGroup.metrics.all_users, approved: userGroup.metrics.approved_users }}
      />
    </Card.Content>
  </CardItem>
);

export default UserGroupCardItem;
